const _ = "modal_6ciU-", o = "modal__backdrop_bngGg", t = "modal__content_OuJmF", n = "modal__content__header_7uYhw", e = "modal__content__header__filled_gCJ-U", d = "modal__content__body_lNIXO", l = "overflowContent_FzUGU", a = {
  modal: _,
  modal__backdrop: o,
  modal__content: t,
  modal__content__header: n,
  modal__content__header__filled: e,
  modal__content__body: d,
  overflowContent: l
};
export {
  a as default,
  _ as modal,
  o as modal__backdrop,
  t as modal__content,
  d as modal__content__body,
  n as modal__content__header,
  e as modal__content__header__filled,
  l as overflowContent
};
//# sourceMappingURL=modal.module.scss.js.map
